import { render, staticRenderFns } from "./AdjustmentsMain.vue?vue&type=template&id=a70f6a7a"
import script from "./AdjustmentsMain.vue?vue&type=script&lang=js"
export * from "./AdjustmentsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports